import { Component, OnInit, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'hr-tab',
    templateUrl: './hr-tab.component.html',
    styleUrls: ['./hr-tab.component.scss'],
    standalone: false
})
export class HrTabComponent implements OnInit {

  constructor() { }


  @Input()
  public label!: string;

  public isActive!: boolean;

  @ViewChild(TemplateRef)
  public tabContent!: TemplateRef<any>



  ngOnInit(): void {
  }

}
